import { Theme } from '@mui/material'

const useStyles = {
  container: (theme: Theme) => ({
    paddingTop: theme.spacing(2),
  }),
  backButton: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  form: {
    width: '100%',
  },
  chipsWrapper: {
    marginTop: '4px',
  },
  rightMargin: (theme: Theme) => ({
    marginRight: theme.spacing(),
  }),
  formFooter: (theme: Theme) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: 'inherit',
    backgroundColor: theme.palette.common.white,
    paddingBottom: theme.spacing(2),
    zIndex: 100,
  }),
  footerDivider: (theme: Theme) => ({
    margin: theme.spacing(2, 0),
  }),
  footerButton: (theme: Theme) => ({
    margin: 'auto',
    padding: theme.spacing(0, 2),
  }),
  extraTopMargin: (theme: Theme) => ({
    marginTop: theme.spacing(8),
  }),
}
export default useStyles
